import useStore from "../../../store"
import { useState, useEffect } from "react"
import TxnRow from "./TxnRow"
import { txnFilter } from "../../../utilities/transferFilter"
import NoResultsFound from "../../common/NoResultsFound"
import { Widget, WidgetBody, WidgetHeader } from "../../ui/Widget"
import SearchBar from "../../common/SearchBar"
import { IoFilterSharp } from "react-icons/io5"
import ReusableDrawer from "../../common/ReusableDrawer"
import { colors } from "../../../utilities/colors"
import DatePickerNoKeyboard from "../../ui/datepicker-no-keyboard"
import { useTranslation } from "react-i18next"
import { NeutralButton } from "../../common/Buttons"
import FilterIndicator from "../../common/FilterIndicator"
import { DateTime } from "luxon"

export default function PastTxns({ handleClick }) {
  const { t } = useTranslation()
  const { paymentTxns, fetchPaymentTxns, isFetchingPaymentTxns, dealer } = useStore()
  const defaultDateFilters = {
    "filter[start_date]": DateTime.local().minus({ months: 1 }).startOf('day'),
    "filter[end_date]": DateTime.local().startOf('day')
  }

  const [showFilters, setShowFilters] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredTxns, setFilteredTxns] = useState([])
  const [startDateOpen, setStartDateOpen] = useState(false)
  const [endDateOpen, setEndDateOpen] = useState(false)
  const [txnParams, setTxnParams] = useState(defaultDateFilters)
  const [filters, setFilters] = useState(defaultDateFilters)

  useEffect(() => {
    fetchPaymentTxns(txnParams)
  }, [txnParams, dealer])

  useEffect(() => {
    setFilteredTxns(txnFilter(paymentTxns, searchTerm))
  }, [paymentTxns, searchTerm])

  return(
    <Widget>
      <WidgetHeader
        title="Past Transactions"
        showSpinner={isFetchingPaymentTxns}
        actionIcon={
            <IoFilterSharp
              onClick={() => setShowFilters(!showFilters)}
              className="hover:cursor-pointer"
            />
        }
      >
        <SearchBar
          onChange={setSearchTerm}
          handleReset={() => setSearchTerm('')}
          value={searchTerm}
        />
        <div className="mt-2">
          <FilterIndicator
            filterName={`${txnParams["filter[start_date]"].toFormat('M/d/yy')} - ${txnParams["filter[end_date]"].toFormat('M/d/yy')}`}
            displayFor={true}
            onClick={() => setShowFilters(!showFilters)}
            displayClearIcon={false}
          />
        </div>
      </WidgetHeader>
      <WidgetBody
        isVisible={!isFetchingPaymentTxns || paymentTxns?.length > 0}
      >
        {filteredTxns.length > 0 ?
          filteredTxns.map((txn) =>
            <TxnRow
              txn={txn}
              filter={searchTerm}
              handleClick={handleClick}
              key={txn.id}/>
          )
        :
          <NoResultsFound/>
        }
      </WidgetBody>

      <ReusableDrawer
        isOpen={showFilters}
        onClose={() => {
          setFilters(txnParams)
          setShowFilters(false)
        }}
        placement="end"
        bgColor={colors.deepOcean}
        title="Filter Past Transactions"
        bodyContent={
          <div className="flex flex-col justify-around my-1 transition-all duration-300">
            <div className="flex flex-col w-full mb-2">
              <span className="text-sm text-grey-300 mb-2">{t("Start Date")}</span>
              <DatePickerNoKeyboard
                selected={filters["filter[start_date]"].toJSDate()}
                open={startDateOpen}
                setOpen={setStartDateOpen}
                onChange={(date) => setFilters({ ...filters, "filter[start_date]": DateTime.fromJSDate(date).startOf('day') })}
                placeholderText="Start Date"
                styles="bg-deep-ocean border-grey focus:border-grey-300"
              />
            </div>
            <div className="flex flex-col w-full mb-2">
              <span className="text-sm text-grey-300 mb-2">{t("End Date")}</span>
              <DatePickerNoKeyboard
                selected={filters["filter[end_date]"].toJSDate()}
                open={endDateOpen}
                setOpen={setEndDateOpen}
                onChange={(date) => setFilters({ ...filters, "filter[end_date]": DateTime.fromJSDate(date).startOf('day') })}
                placeholderText="End Date"
                styles="bg-deep-ocean border-grey focus:border-grey-300"
              />
            </div>
            <NeutralButton
              text="Apply Filters"
              onClick={() => {
                setTxnParams(filters)
                setShowFilters(false)
              }}
            />
          </div>
        }
      />
    </Widget>
  )
}